import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00ffea', // Cyan/turquoise color
      contrastText: '#000'
    },
    secondary: {
      main: '#ff00ff', // Magenta for accents
      contrastText: '#000'
    },
    background: {
      default: '#0a0b0e', // Very dark blue-black
      paper: '#141519', // Slightly lighter dark for cards/papers
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(20, 21, 25, 0.8)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
        },
        contained: {
          background: 'linear-gradient(45deg, #00ffea 30%, #00b8ff 90%)',
          color: '#000',
          '&:hover': {
            background: 'linear-gradient(45deg, #00b8ff 30%, #00ffea 90%)',
          }
        },
        outlined: {
          color: '#fff',
          borderColor: 'rgba(255, 255, 255, 0.5)',
          '&:hover': {
            borderColor: '#fff',
          }
        },
        text: {
          color: '#fff',
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        }
      }
    }
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    }
  },
  shape: {
    borderRadius: 12
  }
});

export default theme; 